import React from 'react';
import { Card, Row, Col, Typography, Button, Space } from 'antd';
import { RocketOutlined, DashboardOutlined, LineChartOutlined, LogoutOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './index.css';

const { Title, Text } = Typography;

const PortalPage: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('auth_token');
    navigate('/login');
  };

  return (
    <div className="portal-container">
      <div className="portal-header">
        <Space align="center" size={12}>
          <RocketOutlined style={{ fontSize: 32, color: '#1890ff' }} />
          <Title level={2} style={{ margin: 0 }}>CheeseSmart 维护端</Title>
        </Space>
        <Button type="text" icon={<LogoutOutlined />} onClick={handleLogout}>退出登录</Button>
      </div>

      <Row gutter={[32, 32]} justify="center" className="portal-content">
        <Col xs={24} md={10} lg={8}>
          <Card 
            hoverable 
            className="portal-card"
            onClick={() => navigate('/')}
          >
            <div className="card-icon-wrapper">
              <LineChartOutlined style={{ fontSize: 48, color: '#1890ff' }} />
            </div>
            <Title level={3}>主分析界面</Title>
            <Text type="secondary">进入全功能量化策略分析、回测与搜索配置界面</Text>
          </Card>
        </Col>

        <Col xs={24} md={10} lg={8}>
          <Card 
            hoverable 
            className="portal-card"
            onClick={() => navigate('/admin')}
          >
            <div className="card-icon-wrapper">
              <DashboardOutlined style={{ fontSize: 48, color: '#52c41a' }} />
            </div>
            <Title level={3}>管理控制台</Title>
            <Text type="secondary">查看订单监控、用户审计、系统状态与日志</Text>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default PortalPage;
